import { responsiveImageProps } from "../utils/responsiveImages";
import React from "react";
import Container from "react-bootstrap/Container";
import { FacebookLogo, InstagramLogo, LinkedinLogo } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { LanguageSwitcher, useLocalization } from "../localization";
import PrivacyChoicesButton from "../privacy/PrivacyChoicesButton";

const socialLinks = [
  {
    name: "Instagram",
    href: "https://www.instagram.com/rauxaapp",
    label: "RAUXA on Instagram (opens in a new tab)",
    Icon: InstagramLogo,
  },
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/company/rauxaapp/",
    label: "RAUXA on LinkedIn (opens in a new tab)",
    Icon: LinkedinLogo,
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61576860841001&mibextid=wwXIfr",
    label: "RAUXA on Facebook (opens in a new tab)",
    Icon: FacebookLogo,
  },
];

const SiteFooter = () => {
  const { t } = useLocalization();

  return (
    <footer className="site-footer">
      <Container className="site-footer-inner">
        <div className="site-footer-brand-block">
          <Link className="site-footer-brand" to="/home" aria-label="RAUXA home">
            <img {...responsiveImageProps("/assets/landing/rauxa-logo.png", "32px")} alt="" />
            <span>RAUXA</span>
          </Link>
          <p>Built for real-world racing, from first idea to finish.</p>
        </div>

        <div className="site-footer-navigation">
          <nav className="site-footer-links" aria-label="Product">
            <Link to="/discover">Discover</Link>
            <Link to="/live-racers">Live Racers</Link>
            <Link to="/organize">Organize a Race</Link>
            <Link to="/seny-i-rauxa">{t("Seny i Rauxa")}</Link>
            <Link to="/careers">{t("Careers")}</Link>
          </nav>
          <nav className="site-footer-links" aria-label="Legal">
            <Link to="/support">Support</Link>
            <Link to="/accessibility">Accessibility</Link>
            <Link to="/legal/terms">Terms &amp; Conditions</Link>
            <Link to="/legal/privacy">Privacy Policy</Link>
            <Link to="/legal/cookies">Cookie &amp; Storage Policy</Link>
            <PrivacyChoicesButton className="site-footer-link-button" />
          </nav>
          <LanguageSwitcher />
        </div>

        <div className="site-footer-bottom">
          <p className="site-footer-copy">
            &copy; {new Date().getFullYear()} RAUXA. All rights reserved.
          </p>
          <nav className="site-footer-social-links" aria-label={t("Social media")}>
            {socialLinks.map(({ name, href, label, Icon }) => (
              <a
                key={name}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t(label)}
              >
                <Icon size={20} aria-hidden="true" focusable="false" />
                <span>{name}</span>
              </a>
            ))}
          </nav>
        </div>
      </Container>
    </footer>
  );
};

export default SiteFooter;
